<template>
  <div class="usuarios-nuevo">
    <div class="content-header">
      <h1 class="content-header-title">Nuevo Usuario</h1>
      <p class="content-header-subtitle">Crear un nuevo usuario</p>
    </div>
    <b-card>
      <b-alert v-if="error" variant="danger" show dismissible @dismissed="error = null">
        {{ error }}
      </b-alert>
      
      <b-form @submit.prevent="guardarUsuario">
        <b-row>
          <b-col md="4">
            <b-form-group label="Nombre" required>
              <b-form-input v-model="usuario.nombre" required />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Primer Apellido" required>
              <b-form-input v-model="usuario.primerApellido" required />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Segundo Apellido">
              <b-form-input v-model="usuario.segundoApellido" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Email" required>
              <b-form-input v-model="usuario.email" type="email" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Rol" required>
              <b-form-select 
                v-model="usuario.idRol" 
                :options="opcionesRol" 
                :disabled="cargandoRoles"
                required 
              />
              <small v-if="cargandoRoles" class="text-muted">Cargando roles...</small>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Contraseña" required>
              <b-form-input v-model="usuario.contrasena" type="password" required />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end gap-2">
          <b-button variant="outline-secondary" @click="volver">Cancelar</b-button>
          <b-button type="submit" variant="primary" :disabled="guardando">
            {{ guardando ? 'Guardando...' : 'Guardar Usuario' }}
          </b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import usuarioService from '@/services/usuarioService'
import rolService from '@/services/rolService'

export default {
  name: 'UsuariosNuevo',
  data() {
    return {
      guardando: false,
      cargandoRoles: false,
      usuario: {
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        email: '',
        idRol: null,
        contrasena: '',
      },
      opcionesRol: [
        { value: null, text: 'Cargando roles...' },
      ],
      error: null,
    }
  },
  async mounted() {
    await this.cargarRoles()
  },
  methods: {
    async cargarRoles() {
      this.cargandoRoles = true
      try {
        const roles = await rolService.getAllRoles()
        
        if (roles.length === 0) {
          this.opcionesRol = [
            { value: null, text: 'No hay roles disponibles' }
          ]
          console.log('No hay roles disponibles')
        } else {
          this.opcionesRol = [
            { value: null, text: 'Seleccionar rol' },
            ...roles.map(rol => ({
              value: rol.idRol,
              text: rol.nombre
            }))
          ]
        }
      } catch (error) {
        console.error('Error al cargar roles:', error)
        
        // Solo mostrar error si no es un 404 (que ya se maneja en el servicio)
        if (error.response?.status !== 404) {
          this.opcionesRol = [
            { value: null, text: 'Error al cargar roles' }
          ]
          this.$toast.error('Error al cargar roles')
        } else {
          // Para 404, mostrar mensaje de no disponibles
          this.opcionesRol = [
            { value: null, text: 'No hay roles disponibles' }
          ]
        }
      } finally {
        this.cargandoRoles = false
      }
    },
    async guardarUsuario() {
      this.guardando = true
      this.error = null
      
      try {
        // Validar campos requeridos
        if (!this.usuario.nombre || !this.usuario.primerApellido || !this.usuario.email || !this.usuario.idRol || !this.usuario.contrasena) {
          this.error = 'Todos los campos marcados como requeridos deben ser completados'
          return
        }

        // Crear el objeto de usuario para enviar al backend
        const usuarioData = {
          nombre: this.usuario.nombre,
          primerApellido: this.usuario.primerApellido,
          segundoApellido: this.usuario.segundoApellido || null,
          email: this.usuario.email,
          idRol: this.usuario.idRol,
          contrasena: this.usuario.contrasena,
        }

        await usuarioService.createUsuario(usuarioData)
        
        this.$toast.success('Usuario creado correctamente')
        this.$router.push({ name: 'usuarios-lista' })
      } catch (error) {
        console.error('Error al crear usuario:', error)
        
        let mensajeError = 'Error al crear el usuario'
        if (error.response?.status === 409) {
          mensajeError = 'Ya existe un usuario con este email'
        } else if (error.response?.status === 400) {
          mensajeError = 'Datos inválidos. Verifique la información ingresada'
        }
        
        this.error = mensajeError
        this.$toast.error(mensajeError)
      } finally {
        this.guardando = false
      }
    },
    volver() {
      this.$router.push({ name: 'usuarios-lista' })
    },
  },
}
</script>

<style lang="scss" scoped>
.usuarios-nuevo {
  padding: 1.5rem;
}

.content-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}

.gap-2 {
  gap: 0.5rem;
}
</style>
